// ============================================================================
// Framer Motion presets
// ----------------------------------------------------------------------------
// Centralised, subtle animation variants used across the site. Keeping these
// in one place ensures consistent timing/easing (per design guidelines).
// ============================================================================

import type { Variants, Transition } from "framer-motion";

export const EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const DURATION = {
  fast: 0.18,
  base: 0.28,
  slow: 0.45,
} as const;

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.slow, ease: EASE },
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: DURATION.slow, ease: EASE } },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.base, ease: EASE },
  },
};

export const cardHover: Transition = { duration: DURATION.fast, ease: EASE };

/** Shared viewport config so reveals fire once, slightly before fully in-view. */
export const viewportOnce = { once: true, amount: 0.2 } as const;
